import { Component, OnInit, Input, ViewChild, ElementRef, Inject, Optional, } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormArray, UntypedFormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppAnalysisService } from 'src/app/app-analysis-module/app-analysis.service';
import { ShareLinkAndEmbedModalComponent } from '../share-link-and-embed-modal/share-link-and-embed-modal.component';
import { ShareMapService } from '../share-map.service';
import { AddNewUserModalComponent } from 'projects/app-home/src/app/add-new-user-modal/add-new-user-modal.component';
import { PricingModalComponent } from 'projects/lib-pricing/src/lib/pricing-modal/pricing-modal.component';
import { MaphelperService } from 'src/app/app-analysis-module/maphelper.service';
import { IsochroneService } from 'src/app/isochrone-module/isochrone.service';
import { AssignUserPopupComponent } from 'src/app/assign-user/assign-user-popup/assign-user-popup.component';
import { AssignUserService } from 'src/app/assign-user/assign-user.service'
import { ShareMapComponent } from '../share-map/share-map.component';
import { AuthService } from 'src/app/_services';
import { Globals } from 'src/app/globals';
// import { AddNewUserModalComponent } from '../add-new-user-modal/add-new-user-modal.component';

@Component({
  selector: 'app-map-preview',
  templateUrl: './map-preview.component.html',
  styleUrls: ['./map-preview.component.css']
})
export class MapPreviewComponent implements OnInit {
  hide = true;
  // @Input() mapLayers: [];
  selectedFile: File = null;
  ShareLayerAllAttributes: any;
  map_Title_Show = '1';
  // navigation_Header='0';
  layerInformation = '1';
  zoomControl = '1';
  NavbarItems = '0';
  searchAddressBar = '1';
  navbarData: any;
  uploadData: FormData;
  layer_attributes = [];
  slidingMenu = '1';
  // mapToolsButton='1';
  attributeList = [];
  allLayersData = [];
  advanced_features: boolean = false;
  passwordProtectedForm: UntypedFormGroup;
  attributeFormGroup: UntypedFormGroup;
  passwordUpdate: any;
  mapTileForm: UntypedFormGroup;
  passwordOption = "PUBLIC";
  BusinessUserList = [];
  seletedBusinessUser: any = [];
  mapHeaderOnOff = '1';
  showHeaderFlex: boolean = true;
  showLayerMenuFlex: boolean = true;
  sideLayerMenuOnOff = '1';
  mapTitleOnOff = '1';
  mapTitleShow: boolean = true;
  mapToolsOnOff = '1';
  template1: boolean = false;
  template2: boolean = false;
  mapId: any;
  mapTitle: any;
  shareType: any = 'shareMap';
  mapName: any;
  sharedOrNot: any;
  layertoggle = true;
  isMapPreview = "1";
  AllLayerData;
  mapPreviewData;
  exactWith: any;
  AddMore: boolean = true
  visible_one: boolean = true
  mapCarto
  assignType = "Private"
  drawData: any;
  tempLayer: any;
  tempMultiple: any;
  layerId: any;
  rasterOn: any;
  layerSelected
  buttonLoader = false;
  activeSubmit = false;
  tempLayerView: any;

  hidePanel = true;

  widthemit(data){
    this.hidePanel = data
    // this.sideWidth = data
  }
  showSide(){
    this.hidePanel = false 
    this.mapCarto.on('idle', (e) => { this.mapCarto.resize() });
  }

  
  @ViewChild(ShareMapComponent, { static: true }) shareMapComponent: ShareMapComponent;



  constructor(private formBuilder: UntypedFormBuilder, private route: ActivatedRoute,
    private AppAnalysisService: AppAnalysisService, private MatDialog: MatDialog,
    private shareMapService: ShareMapService,private AssignUserService: AssignUserService, private mapHelperService: MaphelperService,
    public dialogRef: MatDialogRef<MapPreviewComponent>,
    private _isochroneService: IsochroneService,
    private _router: Router,
    private authenticationService :AuthService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.mapId = this.route.snapshot.paramMap.get('share_map_id');
    this.passwordOption = this.route.snapshot.paramMap.get('share-Type')
    if (this.passwordOption == "embedMap") {
      this.shareType = this.passwordOption
    }
    console.log(this.mapId);
    this.getMapDetails();
    this.mapName = " "
    this.route.params.subscribe((query: any) => {
      console.log(query)
      if(query['share-Type'] != 'PRIVATE'){
        this._isochroneService.ResetLassoHighlightFn(true)
      }
      this.passwordOption = query['share-Type']

      if (this.passwordOption == "embedMap") {
        this.shareType = this.passwordOption
      }else{
        this.shareType = "shareMap"
      }
      // this.layerId = this._route.snapshot.paramMap.get('layer_id')

    })

  }

  fileToUpload: File;
  navbarColor = "#FFFFFF";
  highlightColor = "#FFCC00";
  public addLinkForm: UntypedFormGroup

  layerToggle() {
    this.layertoggle = !this.layertoggle;
  }
  emitexactwith(exactWith) {
    this.exactWith = exactWith
  }

  redirect(data){
    this._router.navigate([`${data}`])
  }

  //Assign User  
  multiplePolygon: boolean;
  cordinates: any = false;
  draw: any;
  mapLayers

  EmitMapLayer(event) {
    this.mapLayers = event
  }

  layerIdChange(layer) {
    // this.SelectedLayerdata = layer

    // this.layerDetails = layer;
    this.layerId = layer.layerid ? layer.layerid : layer.layer_id;
    this.rasterOn = layer.raster_on;
    this.mapCarto.fitBounds(layer.fitBounds);
  }

  emitDraw(event) {
    this.draw = event
  }

  drawDataEmit(data) {
    this.mapHelperService.removeLayerFromMap(
      this.mapCarto,
      this.tempLayer,
      this.tempMultiple
    );
    this.drawData = data;
    let coordinates = this.drawData.features[0].geometry.coordinates[0];
    let stringCoordinates = JSON.stringify({
      type: "Polygon",
      coordinates: [coordinates],
    });

    if (this.assignType == "AssignArea") {
      [this.drawData]
      // this.activeSubmit = true;
      // this.buttonLoader = true;
      // let gis_data = 0
      // this.AppAnalysisService
      //   .lassoHighlight(this.layerId, "intersects", stringCoordinates, "", gis_data)
      //   .subscribe((data) => {
      //     console.log(data);
      //     if (data.data.feature_count == "0") {
      //       this._isochroneService.openSnackBar("Please select any polygon",
      //         "snackbar-error",
      //         "fail")
      //       this.draw.deleteAll();
      //       this.buttonLoader = false;
      //     } else {
      //     let finalResult = data.data;
      //       this.mapHelperService.getLayerJsonData(data.data.dbzxvuwyacs, data.data.view)
      //         .subscribe((result) => {
      //           console.log("Op layer", result);
      //           let tileurl = result["tileurl"] + "?update=" + Math.random();
      //           console.log(tileurl);
      //           // let dbzxvuwyacs = result.dbzxvuwyacs ? result.dbzxvuwyacs : result.dbzxvuwyacs
      //           let layerMapDetails = this.mapHelperService.addLayers(
      //             result.id,
      //             result["geometrytype"],
      //             tileurl,
      //             this.mapCarto,
      //             0,
      //             "red"
      //           );
      //           this.buttonLoader = false;
      //           this.tempLayer = layerMapDetails.source;
      //       this.tempLayerView = finalResult.view

      //           this.tempMultiple = layerMapDetails.multiple;
      //           // this.mapCarto.fitBounds(result["bounds"]);
      //           this.mapCarto = layerMapDetails.map;
      //           data.data.tempLayer = this.tempLayer;
      //           data.data.isMultiple = this.tempMultiple;
      //         });
      //     }
      //   },
      //     (error) => {
      //       console.log("error== ", error);
      //       // this.mapComponent.TurnOnAndOffLayer(this.layerId)
      //     });

    }

  }

  EmitMap(event) {
    this.mapCarto = event
  }

  lassostatus(data) {

  }
  resetButton(data) {
    this.draw.deleteAll()
    this.activeSubmit = false;
    this.mapHelperService.removeLayerFromMap(
      this.mapCarto,
      this.tempLayer,
      this.tempMultiple
    );
  }
  // addLayerOnMapLayer(event){
  //   this.mapComponent.addLayerOnMapLayer(event,0)
  // }

  // setStyleDetailsInMap(event){
  //   this.mapComponent.setStyleDetailsInMapLayers(event.layerid,event.finalSubuserStyle)
  // }

  TurnOffAndOnLayer(event){
    this.shareMapComponent.TurnOffAndOnLayer(event)
  }

  // RecivedSelectedLayer(event){
  //   this.firstLayerSelected= event
  // }

  // SelectedModelEmit(event){
  //   this.SelectedModel = event
  // }

  // End Assign User

  moduleName

  userName:string
  count:any
  finalMaps
  getAllMapUser(){
    this.AppAnalysisService.getAllMapOfUser("","",'gis-analysis').subscribe(
      data => {
        if(data.http_code ==200){
          this.count = data.data.count;
          this.finalMaps = data.data.data;
        }

        
        // this.dataSource = new MatTableDataSource(data.data.data); 
    });
  }

  ngOnInit() {

    this.getCompanyBusinessUsers()
    this.getShareMapDetails();
    this.getMapLayerDetails();
    this.getPlanDetails()
    this.getAllMapUser()

    this.authenticationService.isLoggedIn.subscribe((data) => {
      let isLoggedIn = this.authenticationService.isAuthenticated();
      if(isLoggedIn){
        this.userName = JSON.parse(localStorage.currentUser).data.uname;
      }      

    })




    //  ---------------------Forms--------------------------

    this.passwordProtectedForm = this.formBuilder.group({
      password: ['', Validators.required]
    });

    this.mapTileForm = this.formBuilder.group({
      title: ['', [Validators.required, this.noWhitespaceValidator]]
    });

    this.addLinkForm = this.formBuilder.group({
      itemRows: this.formBuilder.array([this.initItemRows()])
    });


    //--------------------------end  ------------------------

    // this.allLayersData = this.mapLayers;
    //  console.log('---maplayers--->',this.allLayersData);
    // for(let  i=0;i<this.allLayersData.length; i++){
    //   this.layer_attributes.push(this.allLayersData[i]);
    //   }

  
  }

  addLayerOnMapLayer(data){
    this.shareMapComponent.addLayerOnMapLayer(data,0)
  }

  setStyleDetailsInMap(event){
    this.shareMapComponent.setStyleDetailsInMapLayers(event.layerid,event.finalSubuserStyle)
  }



  getMapDetails() {
    this.AppAnalysisService.getMapDetail(this.mapId).subscribe(data => {
      if(data["data"][0].project_type == "map-creator"){
        this.mapName = "map-maker";
      }else{
      this.mapName = data["data"][0].map_name;
      }
      this.mapTitle = this.mapName;
    });
  }

  getMapLayerDetails() {
    this.AppAnalysisService.getAllLayersOfMap(this.mapId).subscribe(data => {
      this.AllLayerData = data;
    })
  }
  SetTerritoryLayersType(data){
this.shareMapComponent.SetTerritoryLayersType(data)
  }

  PlansType;
  getPlanDetails() {
    this.AppAnalysisService.getUserAnalysisPlan().subscribe(data => {
      this.PlansType = data.data.analysis.plan;

      console.log("------------------>plans Type", this.PlansType)
    });
  }





  // ------custome validator for white space validation ------- 
  public noWhitespaceValidator(control: UntypedFormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }
  // ------------end----------

  //get function for shared layer(called on ngOnInit) 
  getShareMapDetails() {
    this.AppAnalysisService.getShareMapDetailsAnalysis(this.mapId).subscribe(data => {
      if (data.data) {
        console.log('get share mapdetail', data)
        this.sharedOrNot = "Shared"
        let shareData = data["data"]
        this.highlightColor = shareData.highlight_color
        this.navbarColor = shareData.navbar_color
        this.zoomControl = shareData.zoom_control
        this.NavbarItems = shareData.navbar_item
        this.searchAddressBar = shareData.search_bar
        this.navbarData = JSON.parse(JSON.parse(shareData.navbar_data))
        this.map_Title_Show = shareData.map_title_on
        this.mapHeaderOnOff = shareData.nav_header
        this.slidingMenu = shareData.menu_slider
        this.mapToolsOnOff = shareData.map_tools
        this.previewLogo = shareData.icon_path
        this.passwordUpdate = shareData.protected_passcode
        let file_Name = this.previewLogo.split('/')
        this.filename = file_Name[file_Name.length - 1]
        if(!this.passwordOption){
          this.passwordOption = shareData.share_mode
        }
 
        this.mapTitle = shareData.map_title
        this.mapTileForm.patchValue({
          title: shareData.map_title
        });

        if (this.navbarData) {
          // this.addLinkForm.controls['itemRows'].patchValue(this.navbarData);
          // this.addLinkForm.controls['itemRows'].setValue(this.navbarData);
          this.addLinkForm.patchValue({
            itemRows: this.navbarData
          });
            console.log(this.addLinkForm.value);
        }


      } else {
        this.sharedOrNot = "Not Shared"
      }
    });
  }

  // -------------------------------------end-----------------------------------------------

  //  ------------------------------------- logo upload ------------------------------------
  filename;
  previewLogo: any = null;
  onFileChanged(event) {
    // this.fileToUpload = files.item(0);
    this.selectedFile = event.target.files[0]
    this.filename = this.selectedFile.name;
    this.preview();
    console.log('input file details ----> ', this.selectedFile);
  }
  preview() {
    // Show preview 
    var logo_file = this.selectedFile.type;
    if (logo_file.match(/image\/*/) == null) {
      return;
    }
    var reader = new FileReader();
    reader.readAsDataURL(this.selectedFile);
    reader.onload = (_event) => {
      this.previewLogo = reader.result;
    }
  }
  cancelFile() {
    this.filename = ""
    this.previewLogo = null
  }
  // ---------------------------------------- end ---------------------------------------------

  get f() { return this.addLinkForm.controls; }
  get p() { return this.mapTileForm.controls; }

  // ---------------------------------------------- On share map click event -------------------------
  ShareBtnLoader = false;
  shareMap() {
    this.ShareBtnLoader = true;
    if (this.PlansType == "FREE" && this.shareType == 'shareMap' &&
      (this.passwordOption == 'PRIVATE')) {
     this.ShareBtnLoader = false;
      const dialogRef = this.MatDialog.open(PricingModalComponent, {
        width: '55%',
        data: { message: "You need to buy plan!" }
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) { }
      });
    }
    let navbar_data = []
    navbar_data = this.f.itemRows.value;
    console.log('link and label', navbar_data);
    console.log("attributeList", this.attributeList)
    this.mapTitle = this.mapTitle == "" ? this.mapName : this.mapTitle;
    const sharedata = new FormData();
    sharedata.append('mapid', this.mapId);
    sharedata.append('icon', this.selectedFile);
    sharedata.append('map_title', this.mapTitle);
    sharedata.append('map_title_on', this.mapTitleOnOff); 
    sharedata.append('nav_header', this.mapHeaderOnOff);
    sharedata.append('navbar_color', this.navbarColor);
    sharedata.append('highlight_color', this.highlightColor);
    sharedata.append('search_bar', this.searchAddressBar);
    sharedata.append('zoom_control', this.zoomControl);
    sharedata.append('navbar_item', this.NavbarItems);
    sharedata.append('navbar_data', JSON.stringify(navbar_data));
    sharedata.append('information_on', this.layerInformation);
    sharedata.append('legend_data', '');
    sharedata.append('map_tools', this.mapToolsOnOff);
    sharedata.append('menu_slider', this.sideLayerMenuOnOff);
    console.log('layer_attribute----->', this.attributeList);
    sharedata.append('share_mode', this.passwordOption);
    sharedata.append('passcode', this.passwordUpdate);
    let ConvertedArray = this.seletedBusinessUser.map(id => parseInt(id));
    sharedata.append('users', JSON.stringify(ConvertedArray));
    console.log('-------- business user list ------>', JSON.stringify(ConvertedArray));

    console.log('this is shared data', sharedata);
    this.shareMapService.shareMap(sharedata).subscribe(data => {
      let mapShareUrl = data["data"].share_details.share_url;
      let mapShareId = data["data"].share_details.shareid;
      console.log(mapShareUrl);
      this.ShareBtnLoader = false;
      if (data.http_code == '200') {
        // Generate a clean map name for the URL
        const cleanMapName = this.mapName.replace(/[^a-zA-Z0-9-_]/g, '-');
        
        // Construct the new URL with the clean map name
        const baseUrl = mapShareUrl.split('/share-map')[0];
        
        const newMapShareUrl = `${Globals.AnalysisProduct}/share-map/${cleanMapName}/${mapShareId}`;
        
        const dialogRef = this.MatDialog.open(ShareLinkAndEmbedModalComponent, {
          data: { "url": newMapShareUrl, "shareType": this.shareType, "mapName": mapShareId }
        });
      }
    }, err => { this.ShareBtnLoader = false; });
  }
  // --------------------------------------------end --------------------------------------------

  //  ------------------------------ form function for adding link --------------------------------
  get addLink() {
    return this.addLinkForm.get('itemRows') as UntypedFormArray;
  }

  initItemRows() {
    return this.formBuilder.group({
      label: ['', Validators.required],
      link: ['', Validators.required]
    });
  }

  addNewLink() {
    this.addLink.push(this.initItemRows());
  }
  menubar: boolean = false;
  menuToggle() {
    this.menubar = !this.menubar;
  }

  DeleteLink(index: number) {
    this.addLink.removeAt(index);
  }
  //  ---------------------------------------end -------------------------------------

  getCompanyBusinessUsers() {
    this.AppAnalysisService.getCompanyBusinessUsers().subscribe(data => {
      for (let i = 0; i < data.data.length; i++) {
        this.BusinessUserList.push(data.data[i])
      }
      console.log('------->>>>>>>>', this.BusinessUserList);
    });
  }

  mapHeaderChangeEvent(data) {
    if (data.checked == true) { 
      this.showHeaderFlex = true
      this.mapHeaderOnOff = "1";
    } else {
      this.showHeaderFlex = false
      this.mapHeaderOnOff = "0";
    } this.mapCarto.on('idle', (e) => { this.mapCarto.resize() });
  }
  layerMenuChangeEvent(data) {
    if (data.checked) {
      this.showLayerMenuFlex = true
      this.sideLayerMenuOnOff = '1'
    } else {
      this.showLayerMenuFlex = false
      this.sideLayerMenuOnOff = '0'
    }
  }
  mapTitleChangeEvent(data) {
    if (data.checked) {
      this.mapTitleShow = true
      this.mapTitleOnOff = '1'
    } else {
      this.mapTitleShow = false
      this.mapTitleOnOff = '0'
    }
  }
  mapToolsChangeEvent(data) {
    if (data.checked) {
      this.mapToolsOnOff = '1'
    } else {
      this.mapToolsOnOff = '0'
    }

  }

  closeModal() {
    this._router.navigateByUrl("/analysis/map/" + this.mapId)
  }

  addNewUser() {
    const dialogRef = this.MatDialog.open(AddNewUserModalComponent, {
      width: '70%',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getCompanyBusinessUsers()
      }
    });
  }
  Addclick() {
    this.AddMore = !this.AddMore; //not equal to condition
    this.visible_one = !this.visible_one
  }



}


